import { render, staticRenderFns } from "./HistoryBill.vue?vue&type=template&id=4332717c&scoped=true&"
import script from "./HistoryBill.vue?vue&type=script&lang=js&"
export * from "./HistoryBill.vue?vue&type=script&lang=js&"
import style0 from "./HistoryBill.vue?vue&type=style&index=0&id=4332717c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4332717c",
  null
  
)

export default component.exports